angular
    .module('empower.termCondition')
    .controller('termConditionController', ['$rootScope', '$scope', 'termConditionServices' , 
        function ($rootScope, $scope, termConditionServices) {
            $scope.termsConditions;

            $scope.init = function () {
                termConditionServices.getTermCondition().then(function (response) {
                    $scope.termsConditions = response;
                });
            }
    }]);
